export var weekdays = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];
export var getEnabledAtDays = function (wd) {
    var weekday_str = "";
    if (wd === 0)
        weekday_str = "выкл.";
    else if (wd === 31)
        weekday_str = "будни";
    else if (wd === 96)
        weekday_str = "выходные";
    else if (wd === 127)
        weekday_str = "все дни";
    else {
        var prev_wday = false;
        for (var i = 0; i < 8; i++) {
            var wd_set = wd & (1 << i);
            if (!prev_wday && wd_set) {
                if (weekday_str.length)
                    weekday_str += ",";
                weekday_str += weekdays[i] || "";
            }
            else if (wd_set) {
                if (weekday_str[weekday_str.length - 1] !== "-")
                    weekday_str += "-";
            }
            if (prev_wday && !wd_set && !weekday_str.endsWith(weekdays[i - 1]))
                weekday_str += weekdays[i - 1] || "";
            prev_wday = wd_set;
        }
    }
    if (weekday_str[weekday_str.length - 1] === "-")
        weekday_str = weekday_str.substr(0, weekday_str.length - 1);
    return weekday_str;
};
